import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import Loading from '../../component/loading'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import { AppContextMenu } from '../../App'

const OrganizationShiftAdd = () => {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('organizationShift')
    }, [])

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [organizations, setOrganizations] = useState([])
    const [selectOrganization, setSelectOrganization] = useState(null)

    // Form state
    const [formData, setFormData] = useState({
        name: '',
    })

    // Check auth
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])

    useEffect(() => {
        setSelectOrganization(
            RequestQueue.getAuthResult()?.user?.organization_id
        )
        if (RequestQueue.getAuthResult()?.user?.role?.name === 'superAdmin') {
            handlerGetOrganizations()
        }
    }, [])

    const handlerGetOrganizations = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/organization`,
            },
            resolve: (res) => {
                setLoading(false)
                setOrganizations(res.data)
                setSelectOrganization(res.data[0]?.id)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const showError = (message) => {
        toast.dismiss()
        toast.error(message, { position: 'bottom-center' })
    }

    // Form handlers
    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async () => {
        setLoading(true)

        await RequestQueue.sendRequest({
            config: {
                method: 'post',
                url: `/shift`,
                data: {
                    name: formData.name,
                    organization_id: selectOrganization,
                },
            },
            resolve: (res) => {
                navigate(-1)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                showError('خطا در   hvjfhx')
            },
        })
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    {/* Form Container */}
                    <div className="box p-0 ">
                        {/* Header */}
                        <div className="m-6 p-6 rounded-md bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h3 className=" text-white font-bold text-xl">
                                <FontAwesomeIcon
                                    icon={faBuilding}
                                    className="ml-2"
                                />
                                افزودن شیفت
                            </h3>
                        </div>

                        {/* Form Content */}
                        <div className="p-6 space-y-6">
                            {RequestQueue.getAuthResult()?.user?.role?.name ===
                                'superAdmin' && (
                                <div className="space-y-2">
                                    <label className=" text-sm font-medium text-gray-700 flex items-center">
                                        <FontAwesomeIcon
                                            icon={faBuilding}
                                            className="ml-2"
                                        />
                                        سازمان
                                    </label>
                                    <select
                                        className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        onChange={(e) => {
                                            setSelectOrganization(
                                                e.target.value
                                            )
                                        }}
                                    >
                                        {organizations.map((d) => {
                                            return (
                                                <option
                                                    value={d.id}
                                                    selected={
                                                        d.id ===
                                                        selectOrganization
                                                    }
                                                >
                                                    {d.name}
                                                </option>
                                            )
                                        })}
                                    </select>
                                </div>
                            )}

                            <div className="flex flex-col w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    نام شیفت
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                                    required
                                />
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col ">
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    className="px-6 maxLg:my-2 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ml-2"
                                    />
                                    انصراف
                                </button>
                                <button
                                    onClick={() => handleSubmit()}
                                    className="px-6 maxLg:my-2 py-3 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="ml-2"
                                    />
                                    ذخیره تغییرات
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default OrganizationShiftAdd
